import { Directive, Input, Renderer2, Injector, OnInit, ElementRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Directive({
    selector: '[farris-set-focus]'
})
export class FarrisSetFocusDirective implements OnInit {

    @Input() set focusState(value: boolean) {
        this._state.next(value);
    }
    private selfEl: HTMLElement
    private _state: BehaviorSubject<any> = new BehaviorSubject({});

    constructor(
        private rd: Renderer2,
        private injector: Injector,
        private el: ElementRef
    ) {

    }

    ngOnInit(): void {
        this.selfEl = this.el.nativeElement;
        this._state.subscribe(data => {
            if (data === false && this.selfEl) {
                if (this.selfEl.nodeName.toLowerCase() === 'farris-html-editor') {
                    this.setHtmlEditorFocus();
                } else {
                    this.setFocus();
                }
            }
        })
    }

    /**
     * è®¾ç½®ä¸è¬è¾å¥æ¡çé»è®¤ç¦ç¹
     */
    setFocus() {
        const input = this.selfEl.querySelectorAll('input');
        if (input.length) {
            input[0].focus()
        } else {
            this.selfEl.focus();
        }
    }

    /**
     * è®¾ç½®htmlç¼è¾å¨çé»è®¤ç¦ç¹  æ»æ¯å¨ææ¬æå
     */
    setHtmlEditorFocus() {
        // å¯ææ¬ç¼è¾å¨ä¸æ¯input
        const ediotrArea = this.selfEl.querySelector('div[contenteditable="true"]');
        //åå»ºrange  å­å¨æµè§å¨å¼å®¹æ§é®é¢
        const range = window.getSelection();
        //range éæ©objä¸ææå­åå®¹
        range.selectAllChildren(ediotrArea);
        //åæ ç§»è³æå
        range.collapseToEnd();
    }
}